import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Link } from 'react-router'

import OrderableTH from '../../navigation/OrderableTH'
import StorePagination from '../../navigation/StorePagination'
import Icon from '../../util/Icon'

import { append } from '../../../utils/url'

@inject('websites', 'auth')
@observer
export default class Websites extends Component {
  state = {
    search: '',
    order_by: 'created_at',
    order_dir: 'desc'
  }

  websites = this.props.websites

  componentWillMount() {
    this.loadPage()
  }

  componentDidMount() {
   this.searchField.focus()
  }

  loadPage(nextPage) {
    const { page=1 } = this.props.location.query
    this.websites.loadPage(nextPage || page, this.state)
  }

  componentWillReceiveProps(nextProps) {
    const { page:next, ...nextQuery } = nextProps.location.query
    const { page:prev, ...prevQuery } = this.props.location.query

    if (next !== prev) {
      this.loadPage(next)
    } else if (nextQuery.order_by !== prevQuery.order_by || nextQuery.order_dir !== prevQuery.order_dir) {
      this.setState(nextQuery, () => this.loadPage())
    }
  }

  handleSearch = ({ target: { value:search } }) => {
    this.setState({ search }, () => this.loadPage())
  }

  renderUnowned(website) {
    window.website = website
    if (this.props.auth.user.reseller_team.id !== website.reseller_team_id) {
      return (
        <Icon icon="exclamation-triangle" />
      )
    }
  }

  render() {
    const { search } = this.state

    return (
      <div className="container padded websites websites-admin">
        <div className="panel full padded">
          <h2 className="title">Websites</h2>
          <div className="table-actions">
            <Link className="button" to="/transfers">Transfer Data</Link>
            <input type="search" placeholder="Search by website or team name; url; user name or email" value={search} onInput={this.handleSearch} ref={(el) => { this.searchField = el }} />
          </div>

          <table className="zebra">
            <thead>
              <tr>
                <OrderableTH query={this.state} field="websites.name">Name</OrderableTH>
                <th>URL</th>
                <OrderableTH query={this.state} field="teams.name">Team</OrderableTH>
                <th>MLS</th>
                <OrderableTH query={this.state} field="created_at" style={{ width: 150 }}>Created On</OrderableTH>
                <OrderableTH query={this.state} field="status" style={{ width: 150 }}>Status</OrderableTH>
              </tr>
            </thead>
            <tbody>
              {this.websites.map(w => (
                <tr key={w.id}>
                  <td>
                    <Link to={append(w.id)}>
                      <img src={w.logo} style={{ height: 20, maxWidth: 40, marginRight: 5 }}/>
                      {w.name} {this.renderUnowned(w)}
                    </Link>
                  </td>
                  <td><Link to={append(w.id)}>{w.root_url ? w.default_url : 'None'}</Link></td>
                  <td><Link to={`/teams/${w.team_id}`}>{w.team_name}</Link></td>
                  <td>{w.mls_permissions.map(m => m.mls_id).join(', ')}</td>
                  <td>{new Date(w.created_at).toDateString()}</td>
                  <td><span className={`website-status-${w.status}`}>{w.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>

          <StorePagination store={this.websites} query={this.state} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/Websites/index.js